'use client'
import type { ChainId } from '@morpho-org/blue-sdk'

import type { DashboardBorrowPositionsFilters } from '@/helpers/filter/table'
import type { UserBorrowPositionFacets } from '@/hooks/positions/userBorrowPositionsQuery'

import { AdvancedAssetFilter, TableNetworkFilter } from '@/components/common/TableAdvancedFilters'
import { userPositionFacetsToAssetItems } from '@/helpers/filter/vaultMasterFilter/getFacetFilters'

interface DashboardBorrowPositionsFiltersProps {
  filters?: DashboardBorrowPositionsFilters
  onFiltersChange?: (filters: DashboardBorrowPositionsFilters) => void
  disabled?: boolean
  positionChainIds?: ChainId[]
  facets?: UserBorrowPositionFacets
}

const DashboardBorrowPositionsFilters = ({
  filters,
  onFiltersChange,
  disabled = false,
  positionChainIds,
  facets
}: DashboardBorrowPositionsFiltersProps) => {
  const collateralAssets = userPositionFacetsToAssetItems(facets?.collateralAssets)
  const loanAssets = userPositionFacetsToAssetItems(facets?.loanAssets)

  const handleCollateralAssetIdsFilterChange = (collateralAssetIdsFilter: string[]) => {
    onFiltersChange?.({
      collateralAssetIdsFilter,
      loanAssetIdsFilter: filters?.loanAssetIdsFilter ?? [],
      chainIdsFilter: filters?.chainIdsFilter ?? []
    })
  }

  const handleLoanAssetIdsFilterChange = (loanAssetIdsFilter: string[]) => {
    onFiltersChange?.({
      collateralAssetIdsFilter: filters?.collateralAssetIdsFilter ?? [],
      loanAssetIdsFilter,
      chainIdsFilter: filters?.chainIdsFilter ?? []
    })
  }

  const handleChainIdsFilterChange = (chainIdsFilter: ChainId[]) => {
    onFiltersChange?.({
      collateralAssetIdsFilter: [],
      loanAssetIdsFilter: [],
      chainIdsFilter
    })
  }

  return (
    <div className="gap-lg max-sm:gap-x-lg max-sm:gap-y-sm flex flex-row flex-wrap items-center">
      <TableNetworkFilter
        chainIdsFilter={filters?.chainIdsFilter ?? []}
        handleChainIdsFilterChange={handleChainIdsFilterChange}
        disabled={disabled || !facets}
        availableChains={positionChainIds}
        page="dashboard_borrow_positions"
      />
      <AdvancedAssetFilter
        label="loan"
        assets={loanAssets}
        assetIdsFilter={filters?.loanAssetIdsFilter ?? []}
        chainIdsFilter={filters?.chainIdsFilter ?? []}
        handleAssetIdsFilterChange={handleLoanAssetIdsFilterChange}
        disabled={disabled || !facets}
        showPTFilter
        page="dashboard_borrow_positions"
      />
      <AdvancedAssetFilter
        label="collateral"
        assets={collateralAssets}
        assetIdsFilter={filters?.collateralAssetIdsFilter ?? []}
        chainIdsFilter={filters?.chainIdsFilter ?? []}
        handleAssetIdsFilterChange={handleCollateralAssetIdsFilterChange}
        disabled={disabled || !facets}
        showPTFilter
        page="dashboard_borrow_positions"
      />
    </div>
  )
}

export default DashboardBorrowPositionsFilters
